import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EarlyReturnPolicy } from "src/common_constants/EnumsConstants/CommonEnums";
import splitDateTimeFormat from "src/utils/splitDateTimeFormat";

export interface ClientSettingsState {
  dateTimeFormat: string;
  fuelLevelFormat: string;
  enableVehicleUsageType?: boolean;
  showAllVehicles?: boolean;
  enablePickupDropoffAddressOverride?: boolean;
  gracePeriod: number;
  fuelUnit: string;
  mileageUnit: string;
  dateOnlyFormat: string;
  language: string;
  needToApply: boolean;
  currency: string;
  currencySymbol: string | null;
  earlyReturnPolicy: string;
  useExtraDurationRates: boolean;
  oneDayForMoreThanXHours: number | null;
  daysForMonth: string;
  statusDisplay: string;
  additionalDriverVisibility?: string;
  addOnChargeSetMaxValue: boolean;
}

const initialSettings: ClientSettingsState = {
  dateTimeFormat: "",
  fuelLevelFormat: "",
  enableVehicleUsageType: false,
  showAllVehicles: false,
  enablePickupDropoffAddressOverride: false,
  gracePeriod: 0,
  fuelUnit: "",
  mileageUnit: "",
  dateOnlyFormat: "",
  language: "en-US",
  needToApply: false,
  currency: "USD",
  currencySymbol: null,
  earlyReturnPolicy: EarlyReturnPolicy.ChargeFullPeriod,
  useExtraDurationRates: false,
  oneDayForMoreThanXHours: null,
  daysForMonth: "Days28",
  statusDisplay: "Labels",
  addOnChargeSetMaxValue: false,
};

const clientSettingsSlice = createSlice({
  name: "clientSettings",
  initialState: initialSettings,
  reducers: {
    setClientSettings(state, action: PayloadAction<ClientSettingsState>) {
      localStorage.setItem("i18nextLng", action.payload.language || "en-US");
      const { dateOnlyFormat } = splitDateTimeFormat(
        action.payload.dateTimeFormat,
      );
      const newState = { ...action.payload, dateOnlyFormat };
      return newState;
    },
    updateClientSettings(
      state,
      action: PayloadAction<Partial<ClientSettingsState>>,
    ) {
      const updatedState = { ...state, ...action.payload };

      return updatedState;
    },

    clearClientSettings() {
      const clearedState: ClientSettingsState = {
        dateTimeFormat: "",
        fuelLevelFormat: "",
        enableVehicleUsageType: false,
        showAllVehicles: false,
        enablePickupDropoffAddressOverride: false,
        gracePeriod: 0,
        fuelUnit: "",
        mileageUnit: "",
        dateOnlyFormat: "",
        language: "en-US",
        currency: "USD",
        currencySymbol: null,
        needToApply: false,
        earlyReturnPolicy: EarlyReturnPolicy.ChargeFullPeriod,
        useExtraDurationRates: false,
        oneDayForMoreThanXHours: null,
        daysForMonth: "Days28",
        statusDisplay: "Labels",
        addOnChargeSetMaxValue: false,
      };
      return clearedState;
    },
  },
});

export const { setClientSettings, updateClientSettings, clearClientSettings } =
  clientSettingsSlice.actions;

export default clientSettingsSlice.reducer;
